<template>
  <div class="resources-page">
    <v-container class="resources-container">
      <div class="resources-header">
        <h1>Resources</h1>
        <p class="intro">
          Free AI Resources for People Breaking Into Tech. Download the curated
          PDF guide to get a detailed guide on how to use each of the AI tools.
        </p>
      </div>

      <v-card class="resource-card" elevation="0">
        <div class="resource-card-inner">
          <div class="resource-badge">Free PDF Guide</div>
          <h2>Free AI Resources for People Breaking Into Tech</h2>
          <p>
            AI is here to stay. In this guide, I share practical tools and
            learning resources that help you move faster. I recommend this for
            anyone breaking into tech, whether you're a student, career changer,
            or someone navigating tech. No Computer Science degree required.
          </p>

          <ul class="resource-list">
            <li>ChatGPT, GitHub Copilot, Gemini, Claude</li>
            <li>Perplexity, Phind, Hugging Face</li>
            <li>freeCodeCamp, DeepLearning.AI, fast.ai</li>
            <li>Microsoft Learn, Google AI Studio, OpenAI Cookbook</li>
            <li>LangChain docs and Roadmap.sh</li>
          </ul>

          <div class="action-row">
            <v-btn
              class="download-btn"
              color="white"
              variant="elevated"
              prepend-icon="mdi-file-pdf-box"
              @click="openGatedResource"
            >
              Open Free AI Resources
            </v-btn>
            <p class="gate-note">
              Subscribe to The Tech Room newsletter and get this guide delivered
              straight to your inbox.
            </p>
          </div>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ResourcesPage",
  data() {
    return {
      gumroadPdfUrl: "https://aishainsweden.gumroad.com/l/aacejw",
    };
  },
  methods: {
    openGatedResource() {
      const isSubscribed =
        window.localStorage.getItem("newsletterSubscribed") === "true";

      if (isSubscribed) {
        window.open(this.gumroadPdfUrl, "_blank", "noopener");
        return;
      }

      this.$router.push({
        name: "Newsletter",
        query: {
          source: "resources",
          redirect: this.$route.fullPath,
          target: this.gumroadPdfUrl,
        },
      });
    },
  },
};
</script>

<style scoped>
.resources-page {
  min-height: calc(100vh - 64px);
  background: linear-gradient(135deg, #f5fdff 0%, #edf8fa 100%);
  padding: 2rem 1rem 3rem;
}

.resources-container {
  max-width: 980px;
}

.resources-header {
  text-align: center;
  margin-bottom: 1.75rem;
}

.resources-header h1 {
  color: #0e3c41;
  font-size: 2.1rem;
  margin-bottom: 0.6rem;
}

.intro {
  max-width: 760px;
  margin: 0 auto;
  color: #35575c;
  line-height: 1.7;
}

.resource-card {
  border: 1px solid #d7ecef;
  border-radius: 16px !important;
  background: #ffffff;
}

.resource-card-inner {
  padding: 1.5rem;
  text-align: left;
}

.resource-badge {
  display: inline-block;
  background: #007f8c;
  color: #ffffff;
  border-radius: 999px;
  padding: 0.25rem 0.7rem;
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 0.8rem;
}

.resource-card h2 {
  color: #10363b;
  font-size: 1.5rem;
  margin-bottom: 0.7rem;
}

.resource-card p {
  color: #41656b;
  line-height: 1.7;
}

.resource-list {
  margin: 1rem 0 1.2rem;
  color: #33575d;
  padding-left: 1.2rem;
}

.resource-list li {
  margin-bottom: 0.5rem;
}

.action-row {
  margin-top: 1rem;
}

.download-btn {
  text-transform: none;
  font-weight: 700;
  color: #007f8c;
}

.gate-note {
  font-size: 0.9rem;
  margin-top: 0.65rem;
  color: #5f7e83;
}

@media (max-width: 768px) {
  .resource-card-inner {
    padding: 1.2rem;
  }

  .resources-header h1 {
    font-size: 1.8rem;
  }

  .download-btn {
    width: 100%;
  }
}
</style>
